import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend } from 'chart.js';

// Register required Chart.js components
ChartJS.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

const HorizontalBarChart = () => {
  const data = {
    labels: ['Category 1', 'Category 2', 'Category 3', 'Category 4', 'Category 5'], // Replace with your categories
    datasets: [
      {
        label: 'Dataset 1',
        data: [12, 19, 3, 5, 2], // Replace with your data
        backgroundColor: 'rgba(75, 192, 192, 0.6)', // Bar color
      },
      {
        label: 'Dataset 2',
        data: [8, 15, 6, 10, 4], // Replace with your data
        backgroundColor: 'rgba(153, 102, 255, 0.6)', // Bar color
      },
    ],
  };

  const options = {
    responsive: true,
    indexAxis: 'y', // This makes the bar chart horizontal
    plugins: {
      legend: {
        position: 'top',
      },
      title: {
        display: true,
        text: 'Horizontal Bar Chart',
      },
    },
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        title: {
          display: true,
          text: 'Categories',
        },
      },
    },
  };

  return <Bar data={data} options={options} />;
};

export default HorizontalBarChart;